module.exports = __webpack_public_path__ + "media/images/ac_templates/201/khaki-a785049a0b6ea55b680cce367f3f76ab.jpg";